import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material/material.module';
import { CustomerService, CustomerServiceControllerService } from '../../core/generated';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-certification-button',
    standalone: true,
    imports: [CommonModule, MaterialModule],
    templateUrl: './certification-button.component.html',
    styleUrls: ['./certification-button.component.scss']
})
export class CertificationButtonComponent {
    private customerServiceService = inject(CustomerServiceControllerService);
    private _snackBar = inject(MatSnackBar);

    @Input() itemId!: number;
    @Input() subject!: string;
    @Input() certified: boolean = false;
    @Output() certificationRequested = new EventEmitter<number>();

    requestCertification() {
        if (!this.certified) {
            const customerService: CustomerService = {
                subject: this.subject,
                requestType: CustomerService.RequestTypeEnum.Certification
            };

            this.customerServiceService.certificationRequest(customerService).subscribe(
                (response) => {
                    if (response && response.subject) {
                        this._snackBar.open(response.subject, '', {
                            duration: 5000,
                        });
                    }
                    this.certificationRequested.emit(this.itemId);
                },
                () => {
                    this._snackBar.open(
                        'Você já tem um registro de atendimento para este pedido.',
                        '',
                        {
                            duration: 5000,
                        }
                    );
                }
            );
        }
    }
}
